import {Component, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {SignInComponent} from "../sign-in/sign-in.component";
import {AuthService} from "../auth/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public dialog: MatDialog, private auth: AuthService, private router: Router) {
  }


  ngOnInit(): void {
    this.auth.isAuthenticated().subscribe(
      res => {
        if (res) this.router.navigate(['upload'])
      }
    )
  }

  openSignInDialog() {
    this.dialog.open(SignInComponent, {
      width: '700px',
      autoFocus: false
    });
  }

}
